let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("edU6Z")).then(() => parcelRequire('lD7ty'));